import React from 'react'
import { fnum } from '../../utils/utils'
import EditInvcForm from './EditInvcForm'
import moment from 'moment'
import { browserHistory } from 'react-router'

export default class InvcItem extends React.Component {

  state = {edit: false}

  onclick = e => {
    e.preventDefault();
    this.setState({edit:true});
  }

  print = e => {
    e.preventDefault();
    e.stopPropagation();
    browserHistory.push('/invoice?id='+this.props.invc.invc_id+'&order_id='+this.props.order.order_id);
  }

  cancelEdit = () => {
    this.setState({edit:false});
  }

  render() {

    const { edit } = this.state;
    const { invc, num, requs, order, editInvc } = this.props;
    const requDesc = requs.hasOwnProperty(invc.invc_requ_id) ?
      requs[invc.invc_requ_id].requ_desc : '';
    if (edit){
      return (
        <EditInvcForm
          num={num}
          editInvc={editInvc}
          order={order}
          data={invc}
          requs={requs}
          cancelEdit={this.cancelEdit}
        />
      );
    }
    else{
      return (
        <tr onClick={this.onclick}>
          <td>{num+1}</td>
          <td>
            <button className="btn btn-success btn-xs" onClick={this.print}>Печать</button>
            {" "+invc.invc_text}
          </td>
          <td className="text-right">{fnum(invc.invc_sum)}</td>
          <td className="text-right">{moment(invc.invc_billed).format("L")}</td>
          <td>{requDesc}</td>
          <td className="text-right">{invc.invc_inv ? "Счет" : ""}{invc.invc_act ? " Акт" : ""}</td>
          <td className="text-right">{invc.invc_num+"/"+invc.invc_year}</td>
        </tr>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/invc/InvcItem.js